(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[17],{

/***/ 4218:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/music/ending",
      function () {
        return __webpack_require__(493);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(7294));
var _router = __webpack_require__(1003);
var _router1 = __webpack_require__(880);
var _useIntersection = __webpack_require__(9246);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    // replace state instead of push if prop is present
    router[replace ? "replace" : "push"](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
    });
}
function Link(props) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var p = props.prefetch !== false;
    var router = (0, _router1).useRouter();
    var ref2 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, props.href, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: props.as ? (0, _router).resolveHref(router, props.as) : resolvedAs || resolvedHref
        };
    }, [
        router,
        props.href,
        props.as
    ]), href = ref2.href, as = ref2.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    var children = props.children, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale;
    if (typeof children === "string") {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (false) {} else {
        child = _react.default.Children.only(children);
    }
    var childRef = child && typeof child === "object" && child.ref;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale);
            }
        }
    };
    childProps.onMouseEnter = function(e) {
        if (child.props && typeof child.props.onMouseEnter === "function") {
            child.props.onMouseEnter(e);
        }
        if ((0, _router).isLocalURL(href)) {
            prefetch(router, href, as, {
                priority: true
            });
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (props.passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale1 = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale1, router && router.locales, router && router.domainLocales);
        childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale1, router && router.defaultLocale));
    }
    return /*#__PURE__*/ _react.default.cloneElement(child, childProps);
}
var _default = Link;
exports["default"] = _default;
if (typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) {
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 5479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Title */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


var Title = function(param) {
    var src = param.src, title = param.title, subtitle = param.subtitle, _additionalClassName = param.additionalClassName, additionalClassName = _additionalClassName === void 0 ? "" : _additionalClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex justify-center relative ".concat(subtitle ? "h-10" : "h-12", " ") + additionalClassName,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: src,
            alt: title,
            layout: "fill",
            objectFit: "contain"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 1796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommonMeta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);


function CommonMeta(param) {
    var _title = param.title, title = _title === void 0 ? "TV\u30A2\u30CB\u30E1\u300E\u60D1\u661F\u306E\u3055\u307F\u3060\u308C\u300F\u516C\u5F0F\u30B5\u30A4\u30C8" : _title, _description = param.description, description = _description === void 0 ? "\u300C\u60D1\u661F\uFF08\u307B\u3057\uFF09\u306E\u3055\u307F\u3060\u308C\u300D2022\u5E74\u590FTV\u30A2\u30CB\u30E1\u653E\u9001\u958B\u59CB\uFF01" : _description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat("https://hoshinosamidare.jp", "/images/ogp.png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width,initial-scale=1.0,viewport-fit=cover"
            })
        ]
    });
};


/***/ }),

/***/ 8593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ DefaultLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8527);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5934);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2748);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _head_commonMeta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1796);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    background: linear-gradient(180deg, #0c062d 0%, #4264e0 15.63%, #6ac3ff 60.06%),\n        linear-gradient(180deg, #0c062d 0%, #6ac3ff 100%);\n    width: 100vw;\n    min-height: 100vh;\n    overflow: hidden;\n    background-attachment: local;\n    @media (max-width: ",
        "px) {\n        background: linear-gradient(180deg, #0c062d 0%, #4264e0 15.63%, #6ac3ff 60.06%),\n            linear-gradient(180deg, #0c062d 0%, #6ac3ff 100%);\n        background-size: 600px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    background: url(/images/bg-top-side.png) no-repeat center top;\n    width: 26%;\n    @media (max-width: ",
        "px) {\n        display: none;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n    @media (max-width: ",
        "px) {\n        position: relative;\n        display: block;\n        height: 140px;\n        width: 100%;\n        background: url(/images/bg-top-sp.png) no-repeat;\n        background-position: center top;\n        background-size: cover;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    text-shadow: 0px 0px 30px #004a7c;\n    position: absolute;\n    top: 40px;\n    left: 132px;\n    font-size: 96px;\n    transform: translateX(calc(-50% + 32px)) rotate(90deg);\n    @media (max-width: 1155px) {\n        font-size: 50px;\n        top: 26px;\n        left: 56px;\n        transform: translateX(calc(-50% + 32px)) rotate(90deg);\n    }\n    @media (max-width: ",
        "px) {\n        display: none;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n    @media (max-width: ",
        "px) {\n        display: inline-block;\n        position: absolute;\n        text-shadow: 0px 0px 30px #004a7c;\n        top: 50%;\n        left: 50%;\n        transform: translateY(-50%) translateX(-50%);\n        font-weight: 400;\n        font-size: 36px;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    top: -36%;\n    left: 15%;\n    height: 250vh;\n    margin: auto;\n    transform: rotate(45deg);\n    width: 100vw;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    width: 1px;\n    height: 80%;\n    top: 0;\n    left: 50%;\n\n    &::after {\n        content: '';\n        display: block;\n        position: absolute;\n        height: 100vh;\n        width: 100%;\n        top: -60%;\n        left: 0;\n        background-color: #ffffff;\n        animation: drop 6s 0s infinite;\n        animation-fill-mode: forwards;\n    }\n\n    :first-of-type {\n        margin-left: -45%;\n        &::after {\n            animation-delay: 1.2s;\n        }\n    }\n    :nth-of-type(2) {\n        margin-left: 12px;\n        &::after {\n            zoom: 0.5;\n            animation-delay: -0.2s;\n        }\n    }\n    :nth-of-type(3) {\n        margin-left: -28%;\n        &::after {\n            animation-delay: 4.5s;\n        }\n    }\n    :nth-of-type(4) {\n        margin-left: 18%;\n        &::after {\n            animation-delay: 3.3s;\n        }\n    }\n    :last-of-type {\n        margin-left: 35%;\n        &::after {\n            animation-delay: 2.5s;\n        }\n    }\n\n    @keyframes drop {\n        0% {\n            top: -45%;\n            height: 100vw;\n        }\n        80% {\n            height: 0;\n        }\n        100% {\n            height: 0;\n            top: 100%;\n        }\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    background: url(/images/bg-bottom-half.png) no-repeat bottom;\n    bottom: 0;\n    text-align: center;\n    font-size: 0.92rem;\n    font-weight: bold;\n    color: #ffffff;\n    letter-spacing: 0.1em;\n    width: 100vw;\n    padding-bottom: 88px;\n    display: flex;\n    align-items: end;\n    justify-content: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    @media (max-width: ",
        "px) {\n        padding-bottom: 48px;\n        font-size: 0.62rem;\n    }\n    @media (max-width: ",
        "px) {\n        background: url(/images/bg-bottom-sp.png) no-repeat bottom;\n        padding-bottom: 16px;\n        font-size: 0.62rem;\n    }\n    @media (orientation: landscape) and (max-width: ",
        "px) {\n        font-size: 0.62rem;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var spWidth = 599;
var pcWidth = 1024;
var tabletWidth = 912;
var Bg = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), spWidth);
var Sky = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].header */ .Z.header(_templateObject1(), spWidth);
var SkySp = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].header */ .Z.header(_templateObject2(), spWidth);
var Main = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].main */ .Z.main(_templateObject3());
var PageTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject4(), spWidth);
var PageTitleSp = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject5(), spWidth);
var Stars = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject6());
var Star = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject7());
var Footer = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].footer */ .Z.footer(_templateObject8(), tabletWidth, spWidth, pcWidth);
var DefaultLayout = function(param) {
    var children = param.children, pageTitle = param.pageTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
        animate: {
            opacity: 1
        },
        initial: {
            opacity: 0
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.5
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Bg, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Sky, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageTitle, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "absolute text-c-secondary w-max h-20 font-RocknRoll tracking-widest",
                            children: pageTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Main, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_head_commonMeta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative w-screen h-[140vh] overflow-hidden pointer-events-none",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Stars, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.h1 */ .E.h1, {
                            animate: {
                                opacity: 1,
                                y: 0
                            },
                            initial: {
                                opacity: 0,
                                y: -100
                            },
                            exit: {
                                opacity: 0
                            },
                            transition: {
                                duration: 1
                            },
                            className: "-mt-[140vh] relative md:w-5/6 w-3/6 max-w-sm lg:h-[24vw] h-[34vw] mx-auto",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
                                href: "/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/images/logo.svg",
                                    alt: "\u60D1\u661F\uFF08\u307B\u3057\uFF09\u306E\u3055\u307F\u3060\u308C",
                                    layout: "fill",
                                    objectFit: "contain"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkySp, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageTitleSp, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-c-secondary w-max font-RocknRoll tracking-widest",
                                    children: pageTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full relative z-[1] mt-8",
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                        className: "md:pt-[25%] pt-[160%]",
                        children: "\xa9\u6C34\u4E0A\u609F\u5FD7\u30FB\u5C11\u5E74\u753B\u5831\u793E\uFF0F\u3042\u308B\u6642\u4EE3\u306E\u6307\u8F2A\u306E\u9A0E\u58EB\u56E3"
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_global_CTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5479);
/* harmony import */ var _components_layout_Default__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8593);




var Ending = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout_Default__WEBPACK_IMPORTED_MODULE_3__/* .DefaultLayout */ .H, {
        pageTitle: "\u697D\u66F2\u60C5\u5831",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mt-12 md:mt-14 max-w-6xl w-[90vw] mx-auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_CTitle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    src: "/images/title/music.svg",
                    title: "\u697D\u66F2\u60C5\u5831",
                    subtitle: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "py-8 md:py-16 px-4 lg:px-44 md:px-12 bg-[#ffff00b3] mt-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-center border-t border-b border-c-secondary p-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-c-primary font-bold",
                                    children: "\u7B2C\u4E00\u671F\u30A8\u30F3\u30C7\u30A3\u30F3\u30B0\u30C6\u30FC\u30DE"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-2xl font-RocknRoll",
                                    children: "\u300CReflexion\u300D"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-40 h-2 mx-auto -mt-[8px] bg-c-secondary"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-lg mt-2 font-RocknRoll",
                                    children: "SpendyMily"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mx-auto mt-8 flex justify-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/images/music/cd-reflexion.png",
                                alt: "reflexion"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "py-8 md:py-16 px-4 lg:px-44 md:px-12 bg-[#ffff00b3] mt-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-center border-t border-b border-c-secondary p-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-c-primary font-bold",
                                    children: "\u30A2\u30FC\u30C6\u30A3\u30B9\u30C8"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-2xl font-RocknRoll",
                                    children: "\u300CSpendyMily\u300D"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-48 h-2 mx-auto -mt-[8px] bg-c-secondary"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mx-auto mt-8 flex justify-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/images/music/reflexion.jpg",
                                alt: "SpendyMily"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-12 leading-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "2020\u5E74\u3001Vo.\u677E\u6C38\u7000\u304Cyukirie\u3001\u5E73\u4E95\u2F42\u3068\u51FA\u4F1A\u3044\u30AA\u30F3\u30E9\u30A4\u30F3\u3067\u306E\u30BB\u30C3\u30B7\u30E7\u30F3\u6D3B\u52D5\u3092\u30B9\u30BF\u30FC\u30C8\u3057\u7D50\u6210\u3002\u53D9\u60C5\u7684\u304B\u3064\u30CF\u30A4\u30C6\u30AF\u30CB\u30C3\u30AF\u306Ayukirie\u306E\u30AE\u30BF\u30FC\u3092\u4E2D\u2F3C\u3068\u3057\u3001 \u65E2\u5B58\u306E\u67A0\u7D44\u307F\u306B\u6349\u308F\u308C\u306A\u3044\u30A2\u30EC\u30F3\u30B8\u3092\u8FFD\u6C42\u3059\u308B\u4E8B\u3067\u3001\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u30B7\u30FC\u30F3\u306B\u304A\u3044\u3066\u56FD\u5185\u5916\u554F\u308F\u305A\u5E45\u5E83\u3044\u2FB3\u697D\u30D5\u30A1\u30F3\u304B\u3089\u306E\u2FBC\u8A55\u4FA1\u3092\u7372\u5F97\u3057\u3066\u3044\u308B\u3002"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "mt-4 text-lg font-RocknRoll",
                            children: "\u30A2\u30FC\u30C6\u30A3\u30B9\u30C8\u30B3\u30E1\u30F3\u30C8"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-44 h-2 mr-auto -mt-[8px] bg-c-secondary"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-2 leading-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "\u3053\u306E\u5EA6\u3001\u300C\u60D1\u661F\u306E\u3055\u307F\u3060\u308C\u300D\u306E\u30A8\u30F3\u30C7\u30A3\u30F3\u30B0\u30C6\u30FC\u30DE\u3092\u62C5\u5F53\u3055\u305B\u3066\u3044\u305F\u3060\u304F\u3053\u3068\u3068\u306A\u308A\u3001\u5927\u5909\u5B09\u3057\u304F\u601D\u3044\u307E\u3059\uFF01"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "md:mt-6 mt-4",
                                    children: "\u539F\u4F5C\u3092\u8AAD\u3093\u3067\u3001\u982D\u306E\u4E2D\u3067\u3069\u3093\u306A\u30A2\u30CB\u30E1\u306B\u306A\u308B\u306E\u304B\u3092\u60F3\u50CF\u3057\u306A\u304C\u3089\u3001\u4E16\u754C\u89B3\u306B\u5BC4\u308A\u6DFB\u3048\u308B\u3088\u3046\u306B\u6B4C\u8A5E\u3092\u66F8\u304B\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3057\u305F\u3002"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "md:mt-6 mt-4",
                                    children: "\u300C\u5149\u3092\u63B4\u3093\u3067\u3044\u3064\u307E\u3067\u3082\u541B\u601D\u3046\u300D\u300C\u6D88\u3048\u308B\u3042\u306E\u65E5\u306E\u9752\u300D"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "md:mt-6 mt-4",
                                    children: "\u306A\u3069\u3001\u6563\u308A\u3070\u3081\u3089\u308C\u305F\u5BFE\u7167\u7684\u306A\u8A00\u8449\u306B\u3088\u3063\u3066\u4EBA\u9593\u306E\u5149\u3068\u5F71\u3092\u8868\u73FE\u3057\u3066\u3044\u308B\u306E\u3067\u3001\u305D\u3053\u306B\u3082\u6CE8\u76EE\u3057\u3066\u9802\u3051\u305F\u3089\u306A\u3068\u601D\u3044\u307E\u3059\u3002"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "md:mt-6 mt-4",
                                    children: "\u30A2\u30CB\u30E1\u300C\u60D1\u661F\u306E\u3055\u307F\u3060\u308C\u300D\u3068\u5171\u306B \u50D5\u9054SpendyMily \u300CReflexion\u300D\u3082\u4E00\u7DD2\u306B\u697D\u3057\u3093\u3067\u3044\u305F\u3060\u3051\u308B\u3068\u5B09\u3057\u3044\u3067\u3059\uFF01"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "md:mt-6 mt-4",
                                    children: "SpendyMily \u677E\u6C38\u7000"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-c-secondary text-center md:mt-12 mt-8 font-RocknRoll md:text-4xl text-xl",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "./",
                        children: "\u4E00\u89A7\u306B\u3082\u3069\u308B"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Ending);


/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1551)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(4218); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);